(() => {
    const ROOT_SELECTOR = 'slider-component.thumbnail-slider';
  
    class ThumbnailSliderScrollbar {
      constructor(root) {
        this.root = root;
        this.slider = root.querySelector('[id^="Slider-"]');
        this.nav = root.querySelector('.slider-nav-container');
        this.track = root.querySelector('.slider-nav-scrollbar__track');
        this.thumb = root.querySelector('.slider-nav-scrollbar__thumb');
  
        if (!this.slider || !this.nav || !this.track || !this.thumb) return;
  
        this.onScroll = this.update.bind(this);
        this.onTrackClick = this.handleTrackClick.bind(this);
        this.onThumbPointerDown = this.handleThumbPointerDown.bind(this);
        this.onPointerMove = this.handlePointerMove.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
  
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('click', this.onTrackClick);
        this.thumb.addEventListener('pointerdown', this.onThumbPointerDown);
  
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.slider);
  
        this.dragging = false;
        this.update();
      }
  
      update() {
        const { scrollWidth, clientWidth, scrollLeft } = this.slider;
        const scrollable = scrollWidth > clientWidth + 1;
  
        this.nav.hidden = !scrollable;
        if (!scrollable) return;
  
        const trackWidth = this.track.clientWidth;
        const ratio = clientWidth / scrollWidth;
        const thumbWidth = Math.max(trackWidth * ratio, 32);
        const maxThumbLeft = trackWidth - thumbWidth;
        const maxScroll = scrollWidth - clientWidth;
        const thumbLeft = maxScroll > 0 ? (scrollLeft / maxScroll) * maxThumbLeft : 0;
  
        this.thumb.style.width = `${thumbWidth}px`;
        this.thumb.style.transform = `translateX(${thumbLeft}px)`;
      }
  
      handleTrackClick(event) {
        if (event.target === this.thumb) return;
  
        const rect = this.track.getBoundingClientRect();
        const thumbWidth = this.thumb.offsetWidth;
        const clickX = event.clientX - rect.left - thumbWidth / 2;
        const maxThumbLeft = rect.width - thumbWidth;
        const ratio = maxThumbLeft > 0 ? clickX / maxThumbLeft : 0;
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
  
        this.slider.scrollTo({
          left: Math.max(0, Math.min(maxScroll, ratio * maxScroll)),
          behavior: 'auto',
        });
      }
  
      handleThumbPointerDown(event) {
        event.preventDefault();
        this.dragging = true;
        this.thumb.classList.add('is-dragging');
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = this.slider.scrollLeft;
        this.thumb.setPointerCapture(event.pointerId);
        this.thumb.addEventListener('pointermove', this.onPointerMove);
        this.thumb.addEventListener('pointerup', this.onPointerUp);
        this.thumb.addEventListener('pointercancel', this.onPointerUp);
      }
  
      handlePointerMove(event) {
        if (!this.dragging) return;
  
        const trackWidth = this.track.clientWidth;
        const thumbWidth = this.thumb.offsetWidth;
        const maxThumbLeft = trackWidth - thumbWidth;
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const deltaX = event.clientX - this.dragStartX;
        const scrollDelta = maxThumbLeft > 0 ? (deltaX / maxThumbLeft) * maxScroll : 0;
  
        this.slider.scrollLeft = this.dragStartScrollLeft + scrollDelta;
      }
  
      handlePointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.thumb.classList.remove('is-dragging');
        this.thumb.releasePointerCapture(event.pointerId);
        this.thumb.removeEventListener('pointermove', this.onPointerMove);
        this.thumb.removeEventListener('pointerup', this.onPointerUp);
        this.thumb.removeEventListener('pointercancel', this.onPointerUp);
      }
  
      destroy() {
        this.slider?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('click', this.onTrackClick);
        this.thumb?.removeEventListener('pointerdown', this.onThumbPointerDown);
        this.resizeObserver?.disconnect();
      }
    }
  
    const instances = new WeakMap();
  
    function init(scope = document) {
      scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        if (instances.has(root)) {
          instances.get(root).destroy();
        }
        const instance = new ThumbnailSliderScrollbar(root);
        if (instance.slider) instances.set(root, instance);
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
  
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();